exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/cabeceracorporativo/cabeceracorporativo.style.css
// module id = ../../../../../src/app/components/common/cabeceracorporativo/cabeceracorporativo.style.css
// module chunks = 0